import env from '../../environment';
import {getCreator, postCreator, putCreator, deleteCreator} from '../../http';

export const endpoints = {
  LIST_CRM_SEGMENTS: `${env.baseApiUrl}/winehouse/admin/crm/segment`,
  CREATE_CRM_SEGMENT: `${env.baseApiUrl}/winehouse/admin/crm/segment`,
  GET_CRM_SEGMENT_BY_ID: `${env.baseApiUrl}/winehouse/admin/crm/segment/:segmentId`,
  EDIT_CRM_SEGMENT: `${env.baseApiUrl}/winehouse/admin/crm/segment/:segmentId`,
  DELETE_CRM_SEGMENT: `${env.baseApiUrl}/winehouse/admin/crm/segment/:segmentId`,

  GET_CRM_SEGMENT_TASK: `${env.baseApiUrl}/winehouse/admin/crm/segment/:segmentId/task`,
  CREATE_CRM_SEGMENT_TASK: `${env.baseApiUrl}/winehouse/admin/crm/segment/task`,

  GET_CRM_SEGMENT_TEMPLATE_FOR_CREATE: `${env.baseApiUrl}/winehouse/admin/crm/segment/template/create`,
  GET_CRM_SEGMENT_TEMPLATE_FOR_UPDATE: `${env.baseApiUrl}/winehouse/admin/crm/segment/template/update`,
};

export const listCrmSegmentsApi = getCreator(endpoints.LIST_CRM_SEGMENTS);
export const createCrmSegmentApi = postCreator(endpoints.CREATE_CRM_SEGMENT);
export const getCrmSegmentByIdApi = getCreator(endpoints.GET_CRM_SEGMENT_BY_ID);

export const editCrmSegmentApi = putCreator(endpoints.EDIT_CRM_SEGMENT);
export const deleteCrmSegmentApi = deleteCreator(endpoints.DELETE_CRM_SEGMENT);

export const getCrmSegmentTaskApi = getCreator(endpoints.GET_CRM_SEGMENT_TASK);
export const createCrmSegmentTaskApi = postCreator(
  endpoints.CREATE_CRM_SEGMENT_TASK
);
